import { useState, useRef, useEffect } from 'react'

import { useLocation } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import Box from '@mui/material/Box'
import { styled, useTheme } from '@mui/material/styles'
import _ from 'lodash'
import themeConfig from 'configs/themeConfig'
import { hexToRGBA } from '@core/utils/hex-to-rgba'
import { useSettings } from '@core/hooks/useSettings'
import Drawer from '@core/components/drawernavigation/Drawer'
import LayoutAppBar from '@core/layouts/components/LayoutAppBar/LayoutAppBar'
import SideMenuHeader from 'pages/components/sidenavbar/SideMenuHeader'
import { SideNavigationItems } from 'navigation/sidenavigationitems/SideNavigationItems'
import SideNavbarItemlist from 'pages/components/sidenavbar/SideNavbarItemlist'
import Storage from '@core/helper/Storage'
import Navigation from 'navigation'
import UpdatePassword from 'views/pages/updatepassword/UpdatePassword'

import { useSelector } from 'react-redux'

const VerticalLayoutWrapper = styled('div')({
  height: '100%',
  display: 'flex'
})

const MainContentWrapper = styled(Box)(() => ({
  flexGrow: 1,
  minWidth: 0,
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column'
}))

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  padding: theme.spacing(3),
  transition: 'padding .25s ease-in-out',
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}))

const StyledBoxForShadow = styled(Box)({
  top: 50,
  left: -8,
  zIndex: 2,
  height: 75,
  display: 'none',
  position: 'absolute',
  pointerEvents: 'none',
  width: 'calc(100% + 15px)',
  '&.d-block': {
    display: 'block'
  }
})

const ListBar = styled(Box)(() => ({
  position: 'relative',
  flexDirection: 'column',
  display: 'flex',
  width: '100%',
  height: '100vh'
}))

const SideNavBarLayout = props => {
  const { hidden } = props
  const { settings, saveSettings } = useSettings()
  const { navCollapsed, contentWidth, skin, navHidden } = settings
  const [permission, setPermission] = useState([])
  const [authUser, setAuthUser] = useState(null)
  const [navVisible, setNavVisible] = useState(hidden ? false : true)
  const [activePath, setActivePath] = useState(null)
  const [navHover, setNavHover] = useState(false)
  const [openResetPasswrd, setResetPassword] = useState(false)
  const { userData } = useSelector(state => state.auth)
  const { navigationSize, collapsedNavigationSize } = themeConfig

  const theme = useTheme()
  const shadowRef = useRef(null)
  const navWidth = navigationSize
  const navigationBorderWidth = skin === 'bordered' ? 1 : 0
  const collapsedNavWidth = collapsedNavigationSize
  const ScrollWrapper = PerfectScrollbar
  let location = useLocation()

  const toggleNavVisibility = () => {
    setNavVisible(!navVisible)
  }
  useEffect(() => {
    if (userData) {
      const dataset1 = JSON.parse(JSON.stringify(userData))
      const datavalue = dataset1?.data?.user
      let removecreateadmin = SideNavigationItems
      functiondata(datavalue, removecreateadmin)
    }
  }, [userData])
  const functiondata = (datavalue, removecreateadmin) => {
    if (datavalue?.config) {
      if (datavalue.role === '2') {
        removecreateadmin = _.reject(SideNavigationItems, n => {
          return n.title === 'Create SubAdmin'
        })
      }
      
      const pushdata = []
      // eslint-disable-next-line array-callback-return
      Object.entries(datavalue?.config).map(([key, value]) => {
        if (value.view) {
          pushdata.push(key)
        }
      })
      let add = pushdata
      if (datavalue.role === '1') {
        add = _.uniq(_.concat(pushdata, 'Create SubAdmin'))
      }

      const datapermission = removecreateadmin.filter(({ name }) =>
        add.includes(name)
      )

      setPermission(datapermission)
    }
  }
  useEffect(() => {
   
    setActivePath(location.pathname)
    

    const fetchs = async () => {
      const data = await Storage.getUserData()
      setAuthUser(data)
    }

    fetchs()
  }, [location, authUser])

  const handleResetPassword = () => {
    setResetPassword(!openResetPasswrd)
  }

  const shadowBgColor = () => {
    if (skin === 'semi-dark' && theme.palette.mode === 'light') {
      return `linear-gradient(${
        theme.palette.customColors.darkBg
      } 40%,${hexToRGBA(
        theme.palette.customColors.darkBg,
        0.1
      )} 95%,${hexToRGBA(theme.palette.customColors.darkBg, 0.05)})`
    } else if (skin === 'semi-dark' && theme.palette.mode === 'dark') {
      return `linear-gradient(${
        theme.palette.customColors.lightBg
      } 40%,${hexToRGBA(
        theme.palette.customColors.lightBg,
        0.1
      )} 95%,${hexToRGBA(theme.palette.customColors.lightBg, 0.05)})`
    } else {
      return `linear-gradient(${
        theme.palette.background.default
      } 40%,${hexToRGBA(theme.palette.background.default, 0.1)} 95%,${hexToRGBA(
        theme.palette.background.default,
        0.05
      )})`
    }
  }

  const handleInfiniteScroll = ref => {
    if (ref) {
      ref._getBoundingClientRect = ref.getBoundingClientRect
      ref.getBoundingClientRect = () => {
        const original = ref._getBoundingClientRect()
        return { ...original, height: Math.floor(original.height) }
      }
    }
  }

  const scrollMenu = container => {
    const scrollContainer = hidden ? (container?.target || container) : container;
    if (!scrollContainer || !shadowRef?.current) return;
    
    const scrollTop = scrollContainer.scrollTop || document.documentElement.scrollTop || 0;
    
    if (scrollTop > 0) {
      if (!shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.add('d-block');
      }
    } else {
      shadowRef.current.classList.remove('d-block');
    }
  }

  if (!authUser || location.pathname === '/error') {
    return null
  }

  return (
    <>
      <VerticalLayoutWrapper className='layout-wrapper'>
        {navHidden ? null : (
          <Drawer
            setNavHover={setNavHover}
            navHover={navHover}
            settings={settings}
            collapsedNavWidth={collapsedNavWidth}
            navWidth={navWidth}
            navigationBorderWidth={navigationBorderWidth}
            hidden={hidden}
            navVisible={navVisible}
            {...props}
          >
            <SideMenuHeader
              toggleNavVisibility={toggleNavVisibility}
              hidden={hidden}
              navHover={navHover}
              collapsedNavWidth={collapsedNavWidth}
              navigationBorderWidth={navigationBorderWidth}
              saveSettings={saveSettings}
              settings={settings}
              {...props}
            />
            <StyledBoxForShadow
              ref={shadowRef}
              sx={{ background: shadowBgColor() }}
            />
            <ScrollWrapper
              containerRef={ref => handleInfiniteScroll(ref)}
              {...{
                options: { wheelPropagation: true },
                onScrollY: container => scrollMenu(container)
              }}
            >
              <ListBar>
                {permission.map((item, index) => {
                  return (
                    <SideNavbarItemlist
                      item={item}
                      index={index}
                      key={index}
                      activePath={activePath}
                      navVisible={navVisible}
                      navHover={navHover}
                      hidden={hidden}
                      settings={settings}
                      collapsedNavWidth={collapsedNavWidth}
                      toggleNavVisibility={toggleNavVisibility}
                      navigationBorderWidth={navigationBorderWidth}
                    />
                  )
                })}
              </ListBar>
            </ScrollWrapper>
          </Drawer>
        )}

        <MainContentWrapper
          className='layout-content-wrapper'
          navcollapsed={navCollapsed.toString()}
        >
          <LayoutAppBar
            settings={settings}
            hidden={hidden}
            toggleNavVisibility={toggleNavVisibility}
            handleResetPassword={handleResetPassword}
          />
          <ContentWrapper
            className='layout-page-content'
            sx={{
              ...(contentWidth === 'boxed' && {
                mx: 'auto',
                '@media (min-width:1440px)': { maxWidth: 1440 },
                '@media (min-width:1200px)': { maxWidth: '100%' }
              })
            }}
          >
            <Navigation activePath={activePath} />
          </ContentWrapper>
        </MainContentWrapper>
      </VerticalLayoutWrapper>
      {openResetPasswrd && (
        <UpdatePassword
          handleResetPassword={handleResetPassword}
          openResetPasswrd={openResetPasswrd}
        />
      )}
    </>
  )
}

export default SideNavBarLayout
